// extracted by mini-css-extract-plugin
export default {"CardTitle":"Cards_CardTitle__4WHaJ","Card":"Cards_Card__rs-r2","LikeButton":"Cards_LikeButton__J-OZK","RemixButton":"Cards_RemixButton__NWoDD"};